import { AxiosResponse } from 'axios';
import { ERROR_TYPES } from '../../../helper/_responseError';

/**
 * 登録導線のエラー種別
 */
export const REGISTER_ERROR_TYPES = {
  ...ERROR_TYPES,
  DUPLICATE_REGISTER: 'duplicate register',
  TOKEN_CHECK_ERROR: 'token check error',
} as const;

type RegisterErrorType = typeof REGISTER_ERROR_TYPES[keyof typeof REGISTER_ERROR_TYPES];

/**
 * 登録導線専用のエラー種別マッパー
 * @param response レスポンスをそのまま詰め込む
 * @returns 登録導線エラー種別
 */
export function registerErrorResultMapper(response: AxiosResponse): [] | RegisterErrorType {
  if (response.data.errorType === 1) {
    // 汎用エラー
    return response.data.errorMessageList;
  }
  if (response.data.errorType === 2) {
    // トークンチェックエラー
    return REGISTER_ERROR_TYPES.TOKEN_CHECK_ERROR;
  }
  if (response.data.errorType === 3) {
    // 登録済みメアド
    return REGISTER_ERROR_TYPES.DUPLICATE_REGISTER;
  }
  throw Error();
}
